import { RootState } from 'redux/configureStore';

export type LoginState = 'login' | 'loading' | 'logout';

export const selectUi = (state: RootState) => state.ui;
